module.exports = __webpack_public_path__ + "img/icon-emote2.74667d84.svg";